import { Mapper } from '../../../common/ddd/mapper.base';
import { IWorkingSessionsAnalyticsActivityEnum } from '../../../common/enum/working-sessions/working-sessions-analytics-activity.enum';
import { SelfDigitalIntensityScoreEntity } from '../../../core/domain/entities/scores/self-digital-intensity-score.entity';

export interface ISelfDigitalIntensityScorePersistenceResponse {
  [IWorkingSessionsAnalyticsActivityEnum.DigitalIntensity]: string;
}

export class SelfDigitalIntensityScoreMapper
  implements Omit<Mapper<SelfDigitalIntensityScoreEntity, any>, 'toResponse'>
{
  toDomain(
    record: ISelfDigitalIntensityScorePersistenceResponse
  ): SelfDigitalIntensityScoreEntity {
    return SelfDigitalIntensityScoreMapper.toDomain(record);
  }

  static toDomain(
    record: ISelfDigitalIntensityScorePersistenceResponse
  ): SelfDigitalIntensityScoreEntity {
    const entity = SelfDigitalIntensityScoreEntity.create({
      digitalIntensityScore: Number(
        record[IWorkingSessionsAnalyticsActivityEnum.DigitalIntensity]
      ),
    });
    return entity;
  }
}
